import styles from "./geneList.module.scss";

import Image from "next/image";
import { nftImageUrl, secondNftImageUrl } from "../../../services/image";
import { Nft, SecondNftForGallery } from "../../../types/nftType";

type Props = {
  geneList: (Nft | SecondNftForGallery)[];
  isBeforeReveal: boolean;
  onClickGene: (gene: Nft | SecondNftForGallery, geneIndex: number) => void;
  isForSecond: boolean;
};

const GeneList = ({
  geneList,
  isBeforeReveal,
  onClickGene,
  isForSecond,
}: Props) => {
  return (
    <div className="mt-6 grid gap-y-[20px] gap-x-[9px] grid-cols-2 lg:grid-cols-5">
      {geneList.map((gene, index) => (
        <div
          key={gene.id}
          className={`${styles.groupItem} relative duration-300 ${styles.fadeIn}`}
        >
          <div
            className={`${styles.geneItem} relative w-full cursor-pointer`}
            onClick={() => {
              onClickGene(gene, index);
            }}
          >
            {/* 画像を圧縮して表示（webp）したい場合は、unoptimizedをfalseにする */}
            <Image
              src={
                isForSecond
                  ? secondNftImageUrl(gene.imageId, true)
                  : nftImageUrl(isBeforeReveal, gene.imageId, true)
              }
              alt="Neural Elective N"
              unoptimized={true}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <p className={styles["gene-item-text"]}>
            GENE N_{gene.tokenId!.padStart(4, "0")}
          </p>
        </div>
      ))}
    </div>
  );
};

export default GeneList;
